import React from 'react'

const Accounting = () => {
  return (
    <div>
      Accounting
    </div>
  )
}

export default Accounting
